export default __webpack_public_path__ + "1a033a4.png";